import axiosClient from 'lib/axiosClient';
import { useSnackbar } from 'notistack';
import { useState } from 'react';

const useDownloadGroupFile = () => {
  const [loading, setLoading] = useState(false);

  const { enqueueSnackbar } = useSnackbar();

  const downloadGroupFile = ({ groupGuid, groupTitle }) => {
    axiosClient
      .get(`SettingProduct/CoddingAttribute/List/Export?Guid=${groupGuid}`, {
        responseType: 'blob',
      })
      .then(res => {
        if (res.status === 200) {
          const type = res.headers['content-type'];
          const blob = new Blob([res.data], {
            type,
            encoding: 'UTF-8',
          });
          const link = document.createElement('a');
          link.href = window.URL.createObjectURL(blob);
          link.download = `${groupTitle}.xlsx`;
          link.click();
        } else {
          enqueueSnackbar(res.message, { variant: 'error' });
        }
      })
      .catch(err => {
        enqueueSnackbar(err.message, { variant: 'error' });
      })
      .finally(() => setLoading(false));
  };

  return [downloadGroupFile, loading];
};

export default useDownloadGroupFile;
